import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2, Shield } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Login() {
    const { user, loading, authError, login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!loading && user) {
            const dest = location.state?.from || (user.role === "admin" ? "/admin" : "/vote");
            navigate(dest, { replace: true });
        }
    }, [user, loading, navigate, location.state]);

    return (
        <div className="App min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1 flex items-center justify-center px-4 py-16">
                <div className="w-full max-w-md">
                    <div className="label-overline text-center">Sign in</div>
                    <h1 className="font-serif text-4xl text-tmc-ink mt-3 text-center">
                        Welcome to TMC
                    </h1>
                    <p className="text-center text-tmc-muted mt-3">
                        Sign in with your Therapy Management Microsoft account
                        to vote for finalists or manage submissions.
                    </p>

                    <div className="mt-10 tmc-card p-8 space-y-5" data-testid="login-card">
                        <button
                            onClick={login}
                            disabled={loading}
                            className="w-full inline-flex items-center justify-center gap-3 bg-[#2F2F2F] hover:bg-black text-white font-semibold py-3 px-5 rounded-full transition-all disabled:opacity-60"
                            data-testid="msal-login-btn"
                        >
                            {loading ? (
                                <Loader2 className="w-4 h-4 animate-spin" />
                            ) : (
                                <svg className="w-5 h-5" viewBox="0 0 21 21" aria-hidden="true">
                                    <rect x="1" y="1" width="9" height="9" fill="#F25022" />
                                    <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
                                    <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
                                    <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
                                </svg>
                            )}
                            Sign in with Microsoft
                        </button>

                        {authError && (
                            <div className="rounded-xl border border-red-200 bg-red-50 text-red-700 px-4 py-3 text-sm" data-testid="login-error">
                                {authError}
                            </div>
                        )}

                        <div className="flex items-start gap-2 text-xs text-tmc-muted pt-2 border-t border-tmc-line">
                            <Shield className="w-3.5 h-3.5 mt-0.5 shrink-0" />
                            <span>
                                Restricted to <strong>@therapymgmt.com</strong> accounts. We never see or store your
                                password — sign-in is handled by Microsoft.
                            </span>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
